import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { TextField } from 'rmwc';

import Dialog from '../dialog/dialog';
import * as styles from '../styles';
import { close,} from '../dialog/actions';
import { incrementPending,decrementPending, login, request, mhelli_web_client_id, loginWithPhoneNumber } from './actions';
import { host } from '../utilities/requests';
import _ from 'lodash';

const cellphoneValidator = /^[0۰][9۹][\d۰-۹]{9}$/;
const cellphonePartialValidator = cellphoneValidator.toPartialMatchRegex();
const passwordValidator = /^.{8,255}$/;
const passwordPartialValidator = passwordValidator.toPartialMatchRegex();
export default class LoginDialog extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    };  

    state = {
        username: '',
        password: '',
        confirmPassword: '',
        cellphone: '',
        activeCode: '',
        isRecovery: false,
        cellphoneValidator,
        passwordValidator,
        isconfirm: false,
        errormsg: '',
        successmsg: '',
        loginWithPhoneNumber:false ,
        markerMobileNumber:'',
        verificationCode:'',
        verificationCodeError:null,
        phoneNumberLoginError:null,
        enterPhonnumber:false,
    }
    set_recovery() { 
        this.setState({
            isRecovery: true,
            errormsg: '',
            successmsg: ''
        });

    }
    set_login() {

        this.setState({
            isRecovery: false,
            errormsg: '',
            successmsg: ''
        });

    }
    goto_reset_pass() {
        this.setState({
            isconfirm: false,
            errormsg: '',
            successmsg: ''
        })
    }
    async reset_pass() {
        // debugger;
        this.setState({
            errormsg: '',
            successmsg: ''
        })
        if (this.state.cellphone.length < 11) {
            this.setState({
                errormsg: 'شماره همراه خود را به صورت صحیح وارد کنید'
            })
        }
        else { 
            var response = await this.context.store.dispatch(request({
                path: `/reset_password/`,
                body: {
                    mobile: this.state.cellphone,
                },
            }));

            if (response.errorId === 0) {
                this.setState({
                    successmsg: response.message,
                    isconfirm: true
                }); 
            }
            else {
                this.setState({
                    errormsg: response.message
                })
            }

        }

    }
    async reset_pass_confirm() {
        // debugger;
        var flag = 0;

        this.setState({
            errormsg: '',
            successmsg: ''
        });

        const validPassword = (
            this.state.password !== '' ||
            !(
                this.props.errors.password ||
                !this.state.password.match(passwordValidator)
            )
        );
        const validCellphone = (
            this.state.cellphone !== '' ||
            !(
                this.props.errors.cellphone ||
                !this.state.cellphone.match(cellphoneValidator)
            )
        );

        if (this.state.activeCode.length === 0) {
            this.setState({
                errormsg: 'کد تائید را وارد کنید'
            });
            flag = 1;
        }


        if (!validPassword) {
            this.setState({
                errormsg: 'برای رمز عبور حداقل 8 حرف وارد کنید'
            });
            flag = 1;
        }

        if (!validCellphone) {
            this.setState({
                errormsg: 'شماره همراه نامعتبر است'
            });
            flag = 1;
        }
        if (this.state.password !== this.state.confirmPassword) {
            this.setState({
                errormsg: 'رمز عبور و تکرار آن یکی نیست '
            });
            flag = 1;
        }

        if (flag === 0) {
            var response = await this.context.store.dispatch(request({
                path: `/reset_password_confirm/`,
                body: {
                    mobile: this.state.cellphone,
                    activeCode: this.state.activeCode,
                    pass: this.state.password
                },
            }));
            if (response.errorId === 0) {  
                await this.context.store.dispatch(login(
                    this.state.cellphone.english(),
                    this.state.password.english(),
                ));
                this.setState({
                    errormsg :'',
                    isconfirm : false,
                    isRecovery : false,
                    successmsg : ''
                });
                this.refs.form.reset();
                this.context.store.dispatch([close(this.props.elementId)]);
            }
            else {
                this.setState({
                    errormsg: response.message
                })
            }

        }

    }
    async markerEnterPhoneNumber(cellphone){
        try{
            this.context.store.dispatch(incrementPending())
            let payload = {
                cellphone,
                verification_code:"",
                grant_type: 'password',
                client_id:mhelli_web_client_id
            }
            const res = await fetch(host + "/o/cellphone-lgoin/" ,{
                method:"POST" ,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })
            var result = await res.json();

            if(result.errorId == 1){
                this.setState({phoneNumberLoginError:null , enterPhonnumber:true})
            }
            else if(result.errorId != 1) {
                this.setState({phoneNumberLoginError:result.message })
            }
        }
        catch(e){
            console.log(e)
        }
        finally{
            this.context.store.dispatch(decrementPending())
        }
    }
    async loginWithPhoneNumberRequest(verification_code ,cellphone ){
        try{
            this.context.store.dispatch(incrementPending())
            let payload = {
                cellphone,
                verification_code,
                grant_type: 'password',
                client_id:mhelli_web_client_id
            }
            const res = await fetch(host + "/o/cellphone-lgoin/" ,{
                method:"POST" ,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })
            var result = await res.json();
            await this.context.store.dispatch(loginWithPhoneNumber(result))
            console.log(result)
            if(result.errorId == 1){
                this.setState({verificationCodeError:null})
            }
            else {
                this.setState({verificationCodeError:result.message })
            }
        }
        catch(e){
            console.log(e)
        }
        finally{
            this.context.store.dispatch(decrementPending())
        }
    }
    renderLoginBody() {
        {
        return <div style={styles.loginDialog}>
            <div
                style={{
                    marginBottom: 0,
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    
                    <p>ورود با شماره همراه</p>
                <br />
                <div >
                    <TextField
                        ref='phoneNumber'
                        style={{ direction: 'ltr'}}
                        rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                        required
                        outlined
                        autoCorrect='off'
                        autoCapitalize='none'
                        type='text'
                        label="شماره همراه"
                        autoComplete="ac-code"
                        value={this.state.markerMobileNumber}
                        onChange={({ target: { value } }) => {
                            this.setState({markerMobileNumber : value.english() })
                            ;
                        }}
                    />
                    <span style={{color:"rgb(255, 64, 129" , marginBottom:"0.6rem"}}>{this.state.phoneNumberLoginError}</span>
                    {this.state.enterPhonnumber && 
                    <TextField
                    ref='code'
                    style={{ direction: 'ltr'}}
                    rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                    required
                    outlined
                    autoCorrect='off'
                    autoCapitalize='none'
                    type='text'
                    label="کد تایید"
                    autoComplete="ac-code"
                    value={this.state.verificationCode}
                    onChange={({ target: { value } }) => {
                        this.setState({ verificationCode: value.english()});
                    }}
                /> 
                }
                <span style={{color:"rgb(255, 64, 129" , marginBottom:"0.6rem"}}>{this.state.verificationCodeError}</span>
                </div>
                <div style={{...styles.dialogButtonContainer , display:"flex" , gap:"15px" , justifyContent:"center"}}>
                    <button
                        type='button'
                        style={styles.defaultDialogButton}
                        onClick={()=>{
                            if(!this.state.enterPhonnumber){
                                this.markerEnterPhoneNumber(this.state.markerMobileNumber.english() || "")
                            }
                            else{
                                this.loginWithPhoneNumberRequest(this.state.verificationCode.english() , this.state.markerMobileNumber.english() || "")
                            }
                        }}
                        >
                        تایید
                    </button>
                </div>
                
            </div>
        </div>
        }
    }
    renderLoginBodyForAdnim(){
        const message = decodeURIComponent(escape(atob(this.context.store.getState().getIn(
            ['routing', 'locationBeforeTransitions', 'query', 'login_message'],
            '',
        ))));
        {
            if (this.state.isRecovery) {
                if (this.state.isconfirm) {
                    return <div style={styles.loginDialog}>
                        {message
                            ? <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em' }}>
                                {message}
                            </div>
                            : null
                        }
                        {
                            this.state.errormsg.length > 0 ?
                                <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em', color: '#f1824e' }}>
                                    {this.state.errormsg}
                                </div> : null
                        }

                        {
                            this.state.successmsg.length > 0 ?
                                <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em', color: 'green' }}>
                                    {this.state.successmsg}
                                </div> : null
                        }
                        <div
                            onKeyPress = {()=>this.reset_pass_confirm()}
                            style={{
                                marginBottom: 0,
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                            <div>
                                شماره همراه : {this.state.cellphone}
                            </div>
                            <br />
                            <div >
                                <TextField
                                    ref='code'
                                    style={{ direction: 'ltr' }}
                                    rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                    required
                                    outlined
                                    autoCorrect='off'
                                    autoCapitalize='none'
                                    type='text'
                                    label='کد بازیابی'
                                    autoComplete="ac-code"
                                    value={this.setState.activeCode}
                                    onChange={({ target: { value } }) => { 
                                        this.setState({ activeCode: value.english() });
                                    }}
                                />
                            </div>

                            <div > 
                                <TextField
                                    ref='new-password'
                                    style={{ direction: 'ltr' }}
                                    rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                    pattern={this.state.passwordValidator.source}
                                    required
                                    outlined
                                    autoCorrect='off'
                                    autoCapitalize='none'
                                    type='password'
                                    autoComplete="new-password"
                                    label={window.gettext('password')}
                                    value={this.state.password}
                                    onChange={({ target: { value } }) => {
                                        value = value.english();
                                        if (value.length > 0 && !value.match(passwordPartialValidator))
                                            return;
                                        this.setState({ password: value });
                                    }}
                                    onFocus={() => this.setState({ passwordValidator: passwordPartialValidator })}
                                    onBlur={() => this.setState({ passwordValidator })}
                                />
                                <div style={styles.error}>
                                    {this.props.errors.password
                                        ? _.map(
                                            this.props.errors.password,
                                            (error, index) => <li style={{ display: 'block' }} key={index}>
                                                * {error}
                                            </li>,
                                        )
                                        : null
                                    }
                                </div>
                            </div>
                            <div >
                                <TextField
                                    ref='confirm_password'
                                    style={{ direction: 'ltr' }}
                                    rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                    pattern={'^$|' + this.state.password}
                                    required
                                    outlined
                                    autoCorrect='off'
                                    autoCapitalize='none'
                                    type='password'
                                    autoComplete="re-new-password"
                                    label={window.gettext('confirm password')}
                                    value={this.state.confirmPassword}
                                    onChange={({ target: { value } }) => this.setState({ confirmPassword: value.english() })}
                                />
                                <div style={styles.error}>
                                    {this.props.errors.confirm_password
                                        ? _.map(
                                            this.props.errors.confirm_password,
                                            (error, index) => <li style={{ display: 'block' }} key={index}>
                                                * {error}
                                            </li>,
                                        )
                                        : null
                                    }
                                </div>
                            </div>

                            <div style={styles.dialogButtonContainer}>
                                <button
                                    key='register'
                                    type='button'
                                    style={styles.dialogButton_large}
                                    onClick={()=>this.reset_pass_confirm()}>
                                    تائید اطلاعات
                                </button>
                            </div>

                            <div>
                                <a
                                    key='reset_pass'
                                    style={styles.reset_pass_btn}
                                    onClick={()=>this.goto_reset_pass()}>
                                    تغییر شماره موبایل
                                </a>
                            </div>
                        </div>
                    </div>

                }
                else {
                    return <div style={styles.loginDialog}>
                        {message
                            ? <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em' }}>
                                {message}
                            </div>
                            : null
                        }
                        {
                            this.state.errormsg.length > 0 ?
                                <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em', color: '#f1824e' }}>
                                    {this.state.errormsg}
                                </div> : null
                        }
                        <div
                            style={{
                                marginBottom: 0,
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                            onKeyPress = {()=>this.reset_pass()}>
                            <div>
                                <TextField
                                    ref='cellphone'
                                    style={{ direction: 'ltr' }}
                                    rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                                    pattern={this.state.cellphoneValidator.source}
                                    required
                                    outlined
                                    autoCorrect='off'
                                    autoCapitalize='none'
                                    label={window.gettext('cellphone')}
                                    value={this.state.cellphone.persian()}
                                    onChange={({ target: { value } }) => {
                                        value = value.english();
                                        if (value.length > 0 && !value.match(cellphonePartialValidator))
                                            return;
                                        this.setState({ cellphone: value });
                                    }}
                                    onFocus={() => this.setState({ cellphoneValidator: cellphonePartialValidator })}
                                    onBlur={() => this.setState({ cellphoneValidator })}
                                />
                                <div style={styles.error}>
                                    {this.props.errors.cell_phone
                                        ? _.map(
                                            this.props.errors.cell_phone,
                                            (error, index) =>
                                                <li style={{ display: 'block' }} key={index}>
                                                    * {error}
                                                </li>,
                                        ) : null
                                    }
                                </div>
                            </div>

                            <div style={styles.dialogButtonContainer}>
                                <button
                                    key='register'
                                    type='button'
                                    style={styles.dialogButton_large}
                                    onClick={()=>this.reset_pass()}>
                                    دریافت کد بازیابی
                                </button>
                            </div>

                            <div>
                                <a
                                    key='reset_pass'
                                    style={styles.reset_pass_btn}
                                    onClick={()=>this.set_login()}>
                                    ورود به حساب کاربری
                                </a>
                            </div>
                        </div>
                    </div>

                }
            }

            else {
                return <div style={styles.loginDialog}>
                    {message
                        ? <div style={{ fontSize: '1.1em', textAlign: 'center', marginBottom: '1em' }}>
                            {message}
                        </div>
                        : null
                    }
                    <form
                        ref='form'
                        style={{
                            marginBottom: 0,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                        onSubmit={async event => {
                            event.preventDefault();
                            try {
                                await this.context.store.dispatch(login(
                                    this.state.username.english(),
                                    this.state.password.english(),
                                ));
                                this.refs.form.reset();
                                this.context.store.dispatch([close(this.props.elementId)]);
                            }
                            catch (exception) {
                                console.error(exception);
                                if(this?.context?.store?.getState()?.toJS()?.application?.sms?.errorId === 1){
                                    this.setState({...this.state ,markerLogin:true })
                                }
                            }
                        }}>
                        <TextField
                            style={{ direction: 'ltr' }}
                            outlined
                            autoCorrect='off'
                            autoCapitalize='none'
                            label={<div style={{ lineHeight: '1.2em' }}>{window.gettext('username') + ' / ' + window.gettext('email')}</div>}
                            value={this.state.username}
                            onChange={({ target: { value } }) => this.setState({ username: value })}
                        />
                        <TextField
                            style={{ direction: 'ltr' }}
                            outlined
                            type='password'
                            label={<div style={{ lineHeight: '1.2em' }}>{window.gettext('password')}</div>}
                            value={this.state.password}
                            onChange={({ target: { value } }) => this.setState({ password: value })}
                        />
                        {/* {this.props.loginError
                            ? <p style={styles.error}>
                                {this.props.loginError.errorDescription
                                    ? window.gettext(this.props.loginError.errorDescription)
                                    : window.gettext('Network error')
                                }
                            </p>
                            : null
                        } */}
                        {this.props.loginError && this?.context?.store?.getState()?.toJS()?.application?.sms?.errorId !== 1
                            ? 
                            <p style={styles.error}>
                                {this.props.loginError.errorDescription
                                    ? window.gettext(this.props.loginError.errorDescription)
                                    : window.gettext('Network error')
                                }
                            </p>
                            : null
                        }
                        <div style={styles.dialogButtonContainer}>
                            {this.props.pending > 0
                                ? <i className='fa-spin fa-spinner fa-2x'></i>
                                : <button
                                    key='submit'
                                    type='submit'
                                    style={styles.defaultDialogButton}>
                                    {window.gettext('login')}
                                </button>
                            }
                        </div>
                        <div style={styles.dialogButtonContainer}>
                            <button
                                key='register'
                                type='button'
                                style={styles.dialogButton}
                                onClick={() => {
                                    this.context.store.dispatch(push({
                                        ...this.context.store.getState().get('routing').get('locationBeforeTransitions').toJS(),
                                        query: { dialog: 'registration' },
                                    }));
                                }}>
                                {window.gettext('register')}
                            </button>
                        </div>
                        <div style={{display:"flex" , justifyContent:"space-around"}}>
                        <div>
                            <a
                                key='reset_pass'
                                style={styles.reset_pass_btn}
                                onClick={()=>this.set_recovery()}>
                                بازیابی رمز عبور
                            </a>
                        </div>
                        </div>

                    </form>
                </div>

            }
        }

    }
    renderBody(){
        let route =this.context.store.getState().getIn(['routing' , 'locationBeforeTransitions','pathname']); 
        let routeState = this.context.store.getState().getIn(['routing' , 'locationBeforeTransitions','state']);
        if(route == "/admin" || routeState == "/admin"){
            if(routeState == "/admin"){
                return this.renderLoginBodyForAdnim.bind(this)();
            }
            else{
                this.context.store.dispatch(push({
                    ...this.context.store.getState().get('routing').get('locationBeforeTransitions'),
                    query: {dialog: 'login'},
                    state:this.context.store.getState().getIn(['routing' , 'locationBeforeTransitions','pathname'])
                }));
            }
        }
        else{
            return this.renderLoginBody.bind(this)();
        }
    }

    render() {
        return <Dialog {...this.props}>
            {this.renderBody.bind(this)()}
            {
                this.state.isRecovery ?
                    <span>
                        <br />
                        <i className='fa-lock fa-3x'></i>
                        <br />
                        بازیابی رمز عبور
                    </span>
                    :
                    <span>
                        <i className='fa-sign-in fa-3x'></i>
                        <br />
                        {window.gettext('log in to account')}
                    </span>
            }
        </Dialog>;
    }
};
